const map = {
	"./auto.png": 7802,
	"./auto_off.png": 8472,
	"./auto_on.png": 364,
	"./mains.png": 8673,
	"./mains_off.png": 6107,
	"./mains_on.png": 9425,
	"./manual.png": 2213,
	"./manual_off.png": 3087,
	"./manual_on.png": 2277,
	"./off.png": 9008,
	"./off_on.png": 4314,
	"./old/auto_off.png": 714,
	"./old/auto_on.png": 9302,
	"./old/mains_off.png": 1109,
	"./old/mains_on.png": 643,
	"./old/manual_off.png": 889,
	"./old/manual_on.png": 8983,
	"./standby.png": 7784,
	"./standby_on.png": 5490
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4380;